import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/passwords/ForgotPassword.css";
import { toast } from "react-toastify";
import { forgotPassword } from "../../services/passwords/forgotpasswordapi";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("login-page");
    return () => document.body.classList.remove("login-page");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Email is required");
      return;
    }

    try {
      setLoading(true);

      const response = await forgotPassword(email);
      toast.success(response.message || "Reset link sent to your email");

      setTimeout(() => navigate("/"), 1500);

    } catch (error) {
      
      const message =
        error?.message ||
        error?.errorMessage ||
        "Something went wrong. Please try again.";

      toast.error(message);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="login-wrapper">
        <div className="login-form-container">
          <h2 className="login-title">Forgot Password</h2>
          <p className="login-subtitle">
            Enter your registered email to receive a reset link
          </p>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label className="input-label">Email Address</label>

              <input
                type="text"
                className="input-field"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="forgot-button-row">
              <button
                type="button"
                className="forgot-back-button"
                onClick={() => navigate("/")}
              >
                Back
              </button>

              <button
                type="submit"
                className="forgot-submit-button"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
